/**
 * Generic modal
 * @method setAlertModal
 */
export function ModalController() {
    //generic
    this.alertModal = null;
    this.confirmModal = null;
    this.loadingModal = null;
    this.loadingDeliveryModal = null;
    this.successModal = null;
    this.errorModal = null;
    //authen
    this.pdpaModal = null;
    //traces and badges
    this.tracesModal = null;
    this.badgesModal = null;
    //redeem
    this.confirmRedeemModal = null;
    this.serialModal = null;
    this.drawDeliveryModal = null;
    this.shippingAddressModal = null;
    this.confirmRedeemRewardModal = null;
    this.confirmUseRewardModal = null;
    this.confirmRedeemSubscriptionModal = null;
    //address
    this.addAddressModal = null;
    this.editAddressModal = null;
    this.listAddressModal = null;
    this.addTaxAddressModal = null;
    this.editTaxAddressModal = null;
    this.listTaxAddressModal = null;
    //otp
    this.otpModal = null;
    this.successModal = null;
    //coupon
    this.confirmCouponModal = null;
    this.conditionCouponModal = null;
    //shopping cart
    this.upsaleModal = null;
    this.confirmTwoButtonModal = null;
    //login
    this.confirmGuestLoginModal = null;
    this.confirmResetPasswordModal = null;
    //My Order
    this.orderDetailModal = null;
    this.orderDeliveryModal = null;
    this.freeGiftModal = null;
    //Store
    this.storeDetailModal = null;
    // notification
    this.notificationModal = null
    // payment
    this.qrPaymentModal = null;
    //pdpa
    this.pdpaModal = null;

    //#region generic
    this.setAlertModal = function(alertModalController) {
        this.alertModal = alertModalController;
    };
    this.setConfirmModal = function (confirmModalController) {
        this.confirmModal = confirmModalController;
    };
    this.setLoadingModal = function (loadingModalController) {
        this.loadingModal = loadingModalController;
    };
    this.setLoadingDeliveryModal = function (loadingDeliveryModalController) {
        this.loadingDeliveryModal = loadingDeliveryModalController;
    };
    this.setSuccessModal = function (successModalController) {
        this.successModal = successModalController;
    };
    this.setErrorModal = function (errorModalController) {
        this.errorModal = errorModalController;
    };
    //#endregion generic

    //#region authen
    this.setPdpaModal = function (pdpaModalController) {
        this.pdpaModal = pdpaModalController;
    };
    //#endregion authen

    //#region traces and badges
    this.setTracesModal = function (tracesModalController) {
        this.tracesModal = tracesModalController;
    };
    this.setBadgesModal = function (badgesModalController) {
        this.badgesModal = badgesModalController;
    };
    //#endregion traces and badges

    //#region redeem
    this.setConfirmRedeemModal = function (confirmRedeemModalController) {
        this.confirmRedeemModal = confirmRedeemModalController;
    };
    this.setSerialModal = function (serialModalController) {
        this.serialModal = serialModalController;
    };
    this.setDrawDeliveryModal = function (drawDeliveryModalController) {
        this.drawDeliveryModal = drawDeliveryModalController;
    };
    this.setShippingAddressModal = function (shippingAddressModalController) {
        this.shippingAddressModal = shippingAddressModalController;
    };
    this.setConfirmRedeemRewardModal = function (confirmRedeemRewardModalController) {
        this.confirmRedeemRewardModal = confirmRedeemRewardModalController;
    };
    this.setConfirmUseRewardModal = function (confirmUseRewardModalController) {
        this.confirmUseRewardModal = confirmUseRewardModalController;
    };
    this.setConfirmRedeemSubscriptionModal = function (confirmRedeemSubscriptionModalController) {
        this.confirmRedeemSubscriptionModal = confirmRedeemSubscriptionModalController;
    };
    //#endregion redeem

    //#region address
    this.setAddAddressModal = function (addAddressModalController) {
        this.addAddressModal = addAddressModalController;
    };
    this.setEditAddressModal = function (editAddressModalController) {
        this.editAddressModal = editAddressModalController;
    };
    this.setListAddressModal = function (listAddressModalController) {
        this.listAddressModal = listAddressModalController;
    };
    this.setAddTaxAddressModal = function (addTaxAddressModalController) {
        this.addTaxAddressModal = addTaxAddressModalController;
    };
    this.setEditTaxAddressModal = function (editTaxAddressModalController) {
        this.editTaxAddressModal = editTaxAddressModalController;
    };
    this.setListTaxAddressModal = function (listTaxAddressModalController) {
        this.listTaxAddressModal = listTaxAddressModalController;
    };
    //#endregion address

    this.setOtpModal = function (otpModalController) {
        this.otpModal = otpModalController;
    };

    this.setSuccessModal = function (successModalController) {
        this.successModal = successModalController;
    };

    //#region coupon
    this.setConfirmCouponModal = function (confirmCouponModalController) {
        this.confirmCouponModal = confirmCouponModalController;
    }
    this.setConditionCouponModal = function (conditionCouponModalController) {
        this.conditionCouponModal = conditionCouponModalController;
    }
    //#endregion coupon

    //#region shopping cart
    this.setUpsaleModal = function (upsaleModalController) {
        this.upsaleModal = upsaleModalController
    }
    this.setConfirmTwoButtonModal = function (confirmTwoButtonModalController) {
        this.confirmTwoButtonModal = confirmTwoButtonModalController
    }
    //#endregion shopping cart

    //#region login
    this.setConfirmGuestLoginModal = function (confirmGuestLoginModalController) {
        this.confirmGuestLoginModal = confirmGuestLoginModalController;
    };
    this.setConfirmResetPasswordModal = function (confirmResetPasswordModalController) {
        this.confirmResetPasswordModal = confirmResetPasswordModalController;
    };
    //#endregion login

    //#region Myorder
    this.setMyorderModal = function (orderDetailModalController) {
        this.orderDetailModal = orderDetailModalController;
    }
    this.setOrderDeliveryModal = function (controller) {
        this.orderDeliveryModal = controller
    }
    this.setFreeGiftModal = function (FreeGiftModalController) {
        this.freeGiftModal = FreeGiftModalController
    }
    //#endregion Myorder

    //#region Store
    this.setStoreDetailModal = function (storeDetailModalController) {
        this.storeDetailModal = storeDetailModalController;
    }
    //#region Store


    //#region custom
    this.setNotificationModal = function(controller){
        this.notificationModal = controller
    }
    //#endregion

    //#region payment
    this.setQRPaymentModal = function(controller){
        this.qrPaymentModal = controller
    }

    // #region pdpa
    this.setPdpaModal = function (pdpaModalController) {
        this.pdpaModal = pdpaModalController;
    };
}
